import actionBuilder, { create } from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

const bulkRemind = (payload, silent = false) => {
  return create(actionType, `${apiPath}/bulk/remind`, { ...payload, silent });
};
const actions = { ...actionBuilder({ apiPath, bulkActionType, actionType }), bulkRemind };

export default actions;
